<template>
  <div>
    <member-label-component
      v-if="showThis"
      @close="close"
      ref="labelComponent"
    />
  </div>
</template>
<script>


export default {
  name: 'DetailsModal',
  components: {

  },
  data () {
    return {
      showThis: false,
      num: 0,
      showList: []
    }
  },
  methods: {
    add (data) {
      const _this = this
      const showList = this.showList
      if (this.showThis == false) {
        this.showThis = true
        this.$nextTick(() => {
          this.$refs.labelComponent.show(data.data_id)
        })
      }
      if (isNotInList(data.id)) showList.push(data.id)
      this.$nextTick(() => {
        _this.$refs.labelComponent.add(data)
      })

      function isNotInList (id) {
        for (var i = 0; i < showList.length; i++) {
          if (showList[i] == id) return false
        }
        return true
      }
    },
    remove (data) {
      const showList = this.showList
      if (this.showThis == false) this.showThis = true
      showList.splice(indexOf(data.id), 1)
      this.$refs.labelComponent.remove(data)

      function indexOf (id) {
        for (var i = 0; i < showList.length; i++) {
          if (showList[i] == id) return i
        }
        return -1
      }
    },
    close () {
      this.showThis = false
    }
  }
}
</script>
